import { render, staticRenderFns } from "./button-create.vue?vue&type=template&id=5075dafe&scoped=true"
import script from "./button-create.vue?vue&type=script&lang=js"
export * from "./button-create.vue?vue&type=script&lang=js"
import style0 from "./button-create.vue?vue&type=style&index=0&id=5075dafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075dafe",
  null
  
)

export default component.exports